import { Box, Typography } from "@mui/material"

export function SkillMapViewEmpty({ hasLines, hasSearch }) {
    if (hasSearch) {
        return (
            <Box sx={{ textAlign: "center", py: 6 }}>
                <Typography variant="body1" color="text.secondary">
                    No trades or skills match your search.
                </Typography>
            </Box>
        )
    }

    if (!hasLines) {
        return (
            <Box sx={{ textAlign: "center", py: 6 }}>
                <Typography variant="body1" color="text.secondary">
                    No skill data was found in your maintenance regimes.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Skills will appear here once your regimes contain tasks with SFG20 skill tags.
                </Typography>
            </Box>
        )
    }

    return (
        <Box sx={{ textAlign: "center", py: 6 }}>
            <Typography variant="body1" color="text.secondary">
                No trades mapped yet. Add a trade to start mapping skills.
            </Typography>
        </Box>
    )
}
